<template>
	<!--TODO translations-->
	<li
		:class="{ 'list-group-my-item': offer.mine, 'just-created': isRecent }"
		class="grid grid-cols-4 lgr:grid-cols-7 p-3 gap-x-3 gap-y-1.5"
	>
		<!-- product -->
		<div class="order-1 col-span-2">
			{{
				__(options.getLabel(offer.product.grade, options.productGradeOptions))
			}}
		</div>

		<!-- date -->
		<div class="order-2 whitespace-nowrap">
			<div v-if="offer.date.type == 'MONTH'">
				{{ datesToMonthSingle(offer.date.month_to) }}
			</div>
			<div v-else-if="offer.date.type == 'AT_HARVEST'">
				{{ __("At harvest") }}
			</div>
			<div v-else>
				{{ datesToMonth(offer.date.month_from, offer.date.month_to) }}
			</div>
		</div>

		<!-- qty -->
		<div class="order-3">{{ offer.qty.mt }} t</div>

		<!-- location -->
		<div class="order-4">
			{{ options.getShortLabel(offer.location.hub, options.standardHubs) }}
		</div>

		<!-- premium -->
		<div class="order-6 lgr:order-5">
			{{ offer.price.type != "FLAT" ? offer.price.basis + " €/t" : "" }}
		</div>

		<!-- price -->
		<div
			class="order-7 lgr:order-6 truncate"
			v-if="offer.price.type == 'BASIS'"
		>
			{{ __("Premium") }}
		</div>
		<div
			v-else
			class="order-7 lgr:order-6 truncate"
			:class="[offer.price.type == 'INDEXED' ? 'text-muted' : '']"
		>
			{{ offer.price.type == "INDEXED" ? "~" : ""
			}}{{
				offer.price.mt
					? $cropOptions.formatLocalizedNumber(offer.price.mt) + " €/t"
					: ""
			}}
		</div>

		<!-- time stamp -->
		<div
			class="order-5 lgr:order-7 text-gray-400 lgr:col-span-2 truncate"
			:class="[offer.mine ? 'd-none d-lg-block' : '']"
		>
			<crop-timeago :date="offer.updated_at" :key="offer.updated_at" />
		</div>

		<!-- CTA offer mine lg:col-start-3 lg:col-end-7 -->
		<div
			v-if="offer.mine"
			class="order-8 text-orange-500 font-medium lgr:col-start-3 lgr:col-end-8 text-right"
		>
			<a
				class="hidden lgr:inline"
				href="#"
				v-on:click.prevent="$emit('edit-offer', offer)"
				>{{ __("Edit my listing") }}</a
			>
			<a
				class="inline lgr:hidden"
				href="#"
				v-on:click.prevent="$emit('edit-offer', offer)"
				>{{ __("Edit") }}</a
			>
			<span
				v-if="isRecent"
				class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-600"
			>
				{{ __("NEW") }}
			</span>
		</div>

		<!-- CTA -->
		<div
			v-if="!offer.mine"
			class="order-8 text-orange-500 font-medium lgr:col-start-3 lgr:col-end-8 text-right"
		>
			<!--
            <div v-if="offer.price.sofort">
                <svg
                    v-if="offer.price.sofort"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    focusable="false"
                    width="1em"
                    height="1em"
                    style="
                        -ms-transform: rotate(360deg);
                        -webkit-transform: rotate(360deg);
                        transform: rotate(360deg);
                    "
                    preserveAspectRatio="xMidYMid meet"
                    viewBox="0 0 24 24"
                >
                    <g
                        fill="none"
                        stroke="#f19300"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 6v6l4 2" />
                    </g>
                </svg>
                <a href="#" class>
                    <span class="mr-2 d-none d-sm-inline-block">{{ __('12 min. left') }}</span>
                    {{ trade == "sell" ? __("Instant sale") : __("Instant purchase") }}
                </a>
            </div>
            -->
			<div
				class="text-orange-500 lgr:col-start-6 lgr:col-end-8 text-right"
				v-if="offer.threads.length == 0"
			>
				<a
					v-on:click.prevent="$bus.$emit('toggle-iframe-modal', placeBidLink)"
					href="#"
				>
					{{ trade == "buy" ? __("Offer") : __("Bid") }}
				</a>
			</div>
			<div class="text-orange-500 col-start-6 col-end-8 text-right" v-else>
				<page-link
					:href="$route('threads') + '?active_id=' + offer.threads[0].id"
				>
					{{ __("To negotiation") }}
				</page-link>
			</div>
		</div>
	</li>
</template>

<script>
let options = require("../../cropOptions.js");

export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		trade: {
			type: String,
			required: true,
		},
	},
	methods: {
		datesToMonth(d1, d2) {
			if (typeof d1 == "string" && typeof d2 == "string") {
				d1 = new Date(d1);
				d2 = new Date(d2);
			}
			if (d1 == null || d2 == null) {
				console.log("AEHM", d1, d2);
			} else if (d1.getFullYear() == d2.getFullYear())
				return (
					d1.getMonth() +
					1 +
					"-" +
					(d2.getMonth() + 1) +
					"/" +
					d1.getYear().toString().substr(-2)
				);
			else
				return (
					d1.getMonth() +
					1 +
					"/" +
					d1.getYear().toString().substr(-2) +
					"-" +
					(d2.getMonth() + 1) +
					"/" +
					d2.getYear().toString().substr(-2)
				);
		},
		datesToMonthSingle(d1) {
			if (typeof d1 == "string") {
				d1 = new Date(d1);
			}
			return [d1.getMonth() + 1, "/", d1.getYear().toString().substr(-2)].join(
				""
			);
		},
	},
	data() {
		return {
			options: options,
		};
	},
	computed: {
		placeBidLink() {
			return this.$route("paper.createBid", {
				targetType: "offer_" + this.trade.toLowerCase(),
				targetId: this.offer.id,
			});
		},
		isRecent() {
			let secondsAgo = (Date.now() - new Date(this.offer.updated_at)) / 1000;
			return secondsAgo < 60;
		},
	},
};
</script>
